export default __webpack_public_path__ + "static/media/kube.37fa523e.png";